import { Link } from 'react-router-dom'
import { LoginForm } from '../components/auth/LoginForm'

export function LoginPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white mb-2">🏃 Relay Tracker</h1>
          <p className="text-gray-400">Reno Tahoe Odyssey Race Tracking</p>
          <p className="text-gray-600 text-xs mt-1">v{__APP_VERSION__} &middot; Built {new Date(__BUILD_TIME__).toLocaleString('en-US', { timeZone: 'America/Los_Angeles', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })}</p>
        </div>

        {/* Login Card */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-8">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-6">Login</h2>
          <LoginForm />
        </div>

        {/* Register link */}
        <p className="text-center text-sm text-gray-500 mt-4">
          Race organizer?{' '}
          <Link to="/register" className="text-indigo-400 hover:text-indigo-300 underline">
            Register with your race code
          </Link>
        </p>

        {/* Footer */}
        <div className="text-center mt-8 text-gray-500 text-sm space-y-2">
          <p>📱 Mobile-first PWA</p>
          <p>🔒 Secure JWT Authentication</p>
          <p>📍 Real-time GPS Tracking</p>
          <p className="pt-2">
            <Link to="/consent" className="text-gray-500 hover:text-gray-300 underline text-xs">
              SMS Consent &amp; Privacy Notice
            </Link>
          </p>
          <p className="pt-1">
            <Link to="/sms-example" className="text-gray-500 hover:text-gray-300 underline text-xs">
              Example: Text Message Opt In / Opt Out
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}
